import React, { useState, useEffect, useContext } from "react"
import { useDispatch, useSelector } from "react-redux";
import { Slider } from "@material-ui/core";
import CurrencyFormat from 'react-currency-format';
import SocketContext from "../../context/SocketContext";
import { useTranslation } from "react-i18next";
import { Link, NavLink, useNavigate } from "react-router-dom";

//import api
import { orderPlace, updateTradeAsset } from "../../api/tradeAction"

//import lib
import { encryptObject } from "../../lib/cryptoJS"
import { toFixedDown, truncateDecimals } from "../../lib/roundOf"
import { toastAlert } from "../../lib/toastAlert";
import isEmpty from '../../lib/isEmpty';

//import validation
import { OrderValidate } from "./validation"
import { Modal } from "react-bootstrap";



function valuetext(value) {
    return `${value}%`;
}


const initialFormValue = {
    quantity: 0,
    price: 0,
    leverage: 0,
    isCloseModal: false,
    isLoss: false,
    isProfit: false,
    takeProfit: 0,
    stopLoss: 0,
}

const Orderplace = (props) => {

    //props
    const { type, pairData, refetch, totalpair, pendingrefetch } = props

    //state
    const [formValue, setFormValue] = useState(initialFormValue);
    const [loader, setLoader] = useState(false);
    const [isProfitModal, setisProfitModal] = useState(false);
    const [isLossModal, setisLossModal] = useState(false);
    const [tppnl, settppnl] = useState(0);
    const [slpnl, setslpnl] = useState(0);

    const { quantity, price, leverage, isProfit,
        takeProfit,
        stopLoss,
        isLoss, } = formValue;

    const socketContext = useContext(SocketContext);
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()

    //redux
    const { firstCurrency, secondCurrency } = useSelector(
        (state) => state.tradeAsset
    );
    const priceConversion = useSelector((state) => state.priceConversion);
    const tradePair = useSelector((state) => state.tradePair);
    const marketPrice = useSelector((state) => state.marketPrice)

    //function
    const handleTotal = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        // if (name == "quantity") {
        //     if (/[^0-9.]/.test(value)) return;
        // }
        let formData = { ...formValue, ...{ [name]: toFixedDown(value, tradePair?.secondFloatDigit) } };
        setFormValue(formData);
        if (value) {
            setLoader(false)
        }
    };

    const handleMax = () => {
        let total = secondCurrency?.stakeBal - secondCurrency?.lockedBal
        let Markprice = type === "buy" ? marketPrice?.askPrice : marketPrice?.bidPrice;
        let price = total / Markprice * tradePair?.leverage
        let formData = { ...formValue, ...{ ["quantity"]: toFixedDown(price, tradePair?.secondFloatDigit) } };
        setFormValue(formData);
    }


    const handleClick = (value) => {
        try {
            let amount = quantity
            if (value === 'sub' && amount > 0) {
                amount--
            } else if (value === 'add') {
                amount++
            }
            let formData = { ...formValue, ...{ ["quantity"]: toFixedDown(amount, tradePair.secondFloatDigit) } };
            setFormValue(formData);
        } catch (err) {
            console.log(err, 'errror')
        }
    }


    const handleSubmit = async () => {
        try {
            let reqData = {
                price: price,
                quantity: quantity,
                buyorsell: type,
                pairId: tradePair.pairId,
                newdate: new Date(),
                action: "open",
                isTP: isProfit,
                isSL: isLoss,
                takeProfit,
                stopLoss,
            };
            const validateError = await OrderValidate(reqData);
            if (!isEmpty(validateError)) {
                setLoader(false);
                toastAlert("error", t(validateError[Object.keys(validateError)[0]]), "limitOrder");
                return;
            }

            let encryptToken = {
                token: encryptObject(reqData),
            };
            setLoader(true);
            let { status, message, error, il8 } = await orderPlace(
                encryptToken
            )
            setTimeout(() => {
                setLoader(false);
            }, 500)
            if (status == "success") {
                let formData = {
                    ...formValue,
                    ...{
                        isLoss: false,
                        isProfit: false,
                        stopLoss: 0,
                        takeProfit: 0,
                    },
                };
                setFormValue(formData);
                toastAlert("success", t(message, il8), "spotOrder");
                refetch()
                pendingrefetch()
            } else {
                setLoader(false);
                if (!isEmpty(error)) {
                    toastAlert("error", error[Object.keys(error)[0]], "limitOrder");
                    return;
                }
                toastAlert("error", t(message, il8), "spotOrder");
            }
        } catch (err) {
            setLoader(false);
            console.log(err, 'errror')
        }
    };


    const handleTPSL = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        if (name == "takeProfit" || name == "stopLoss") {
            if (/[^0-9.]/.test(value)) return;
        }
        let formData = { ...formValue, ...{ [name]: toFixedDown(value, 8) } };
        setFormValue(formData);
        if (value) {
            setLoader(false);
        }

        PnLCalc(value, name);
    };

    const TPCloseModal = () => {
        setisProfitModal(false);
        let formData = {
            ...formValue,
            ...{
                isCloseModal: false,
                isProfit: false,
                takeProfit: 0,
            },
        };
        setFormValue(formData);
        settppnl(0);
    };
    const SLCloseModal = () => {
        setisLossModal(false);
        let formData = {
            ...formValue,
            ...{
                isCloseModal: false,
                isLoss: false,
                stopLoss: 0,
            },
        };
        setFormValue(formData);
        setslpnl(0);
    };

    const handleUpdate = async () => {
        let filter =
            totalpair &&
            totalpair.find(
                (el) => el._id.toString() == tradePair.pairId.toString()
            );
        console.log(isLoss, isProfit, filter, "gfddfgdafsg");
        if (isProfitModal) {
            if (isEmpty(takeProfit) || takeProfit === "" || takeProfit === 0) {
                toastAlert(
                    "error",
                    t("TAKE_PROFIT_REQUIRED"),
                    "marketOrder_tp"
                );
                return;
            }

            if (type == "buy") {
                if (!isEmpty(takeProfit) && takeProfit < filter?.markPrice) {
                    toastAlert(
                        "error",
                        t("TAKE_PROFIT_GREATER"),
                        "marketOrder_tp"
                    );
                    return;
                }
            } else {
                if (!isEmpty(takeProfit) && takeProfit > filter?.markPrice) {
                    toastAlert(
                        "error",
                        t("TAKE_PROFIT_LESSER"),
                        "marketOrder_tp"
                    );
                    return;
                }
            }
        } else if (isLossModal) {
            console.log(stopLoss, "stopLoss");
            if (isEmpty(stopLoss) || stopLoss === "" || stopLoss === 0) {
                toastAlert("error", t("STOP_LOSS_REQUIRED"), "marketOrder_tp");
                return;
            }

            if (type == "buy") {
                if (!isEmpty(stopLoss) && stopLoss > filter?.markPrice) {
                    toastAlert(
                        "error",
                        t("STOP_LOSS_GREATER"),
                        "marketOrder_sl"
                    );
                    return;
                }
            } else {
                if (!isEmpty(stopLoss) && stopLoss < filter?.markPrice) {
                    toastAlert(
                        "error",
                        t("STOP_LOSS_LESSER"),
                        "marketOrder_sl"
                    );
                    return;
                }
            }
        }
        setLoader(false);
        let formData = {
            ...formValue,
            ...{
                isCloseModal: false,
            },
        };
        setFormValue(formData);
        setisLossModal(false);
        setisProfitModal(false);
    };

    const PnLCalc = (lastPrice, name) => {
        try {
            let entryPrice = parseFloat(
                type === "buy" ? marketPrice?.askPrice : marketPrice?.bidPrice
            );
            let exitPrice = parseFloat(lastPrice);
            let qty = parseFloat(quantity);

            if (entryPrice > 0 && exitPrice > 0 && qty > 0) {
                if (type == "buy") {
                    if (name == "takeProfit") {
                        settppnl(qty * (exitPrice - entryPrice));
                    } else {
                        setslpnl(qty * (exitPrice - entryPrice));
                    }
                } else if (type == "sell") {
                    if (name == "takeProfit") {
                        settppnl(qty * (entryPrice - exitPrice));
                    } else {
                        setslpnl(qty * (entryPrice - exitPrice));
                    }
                }
            } else {
                if (name == "takeProfit") {
                    settppnl(0);
                } else {
                    setslpnl(0);
                }
            }
        } catch (err) {
            console.log("err: ", err);
            if (name == "takeProfit") {
                settppnl(0);
            } else {
                setslpnl(0);
            }
        }
    };

    useEffect(() => {
        setFormValue({ ...formValue, ...{ ["leverage"]: pairData?.leverage } })
    }, [type, pairData, quantity, priceConversion, marketPrice])



    useEffect(() => {
        // socket
        socketContext.socket.on("updateTradeAsset", (result) => {
            updateTradeAsset(dispatch, result);
        });
    }, []);

    useEffect(() => {
        let formData = {
            ...formValue,
            ...{
                isLoss: false,
                isProfit: false,
                stopLoss: 0,
                takeProfit: 0,
            },
        };
        setFormValue(formData);
    }, [type]);

    // console.log(loader, 'marketPricemarketPrice')
    let Balance = secondCurrency.stakeBal - secondCurrency.lockedBal
    let margin = marketPrice?.markPrice * (quantity / 100)
    console.log(price, "pricepricepriceprice")
    return (
        <>

            <div class="form-group">
                <div className="d-flex justify-content-between gap-10 flex-wrap">
                    <label for="amount" class="form-label">
                        {t("QUANTITY")}
                    </label>
                    <label class="form-label">{t('AVAILABLE_BALANCE')}: <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(Balance, tradePair.secondFloatDigit)} /> {pairData.secondCurrencySymbol}</label>
                </div>
                <div className="mt-1 w-full self-stretch h-[47px] p-3 rounded-sm outline outline-1 outline-offset-[-1px] outline-gray-500/25 inline-flex justify-start items-center gap-3">
                    <div className=" relative bg-neutral-700 overflow-hidden cursor-pointer" onClick={() => handleClick("sub")}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="20" height="20" fill="#395645" />
                            <path d="M15.8343 10H4.16602" stroke="white" stroke-width="1.5" stroke-linecap="square" />
                        </svg>
                    </div>
                    <div className="flex-1 flex justify-start items-center gap-2.5">
                        <input
                            type="number"
                            className="cus_input w-full !bg-transparent !border-none outline-none justify-center text-neutral-700 text-sm font-semibold font-['Roobert']"
                            name="quantity"
                            value={quantity}
                            onChange={handleTotal}
                            placeholder={t("QUANTITY_PLACEHOLDER")}
                        />
                    </div>
                    <div className=" relative bg-neutral-700 overflow-hidden cursor-pointer" onClick={() => handleClick("add")}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="20" height="20" fill="#395645" />
                            <path d="M10 4.16602V15.8343" stroke="white" stroke-width="1.5" stroke-linecap="square" />
                            <path d="M15.8344 10.002H4.16602" stroke="white" stroke-width="1.5" stroke-linecap="square" />
                        </svg>
                    </div>
                </div>
                <div className="d-flex justify-content-between gap-10 flex-wrap">
                    <label for="amount" class="form-label">
                    </label>
                    <label className="max_label"
                        onClick={handleMax}
                    >{t("MAX")}</label>
                </div>
            </div>

            <div className="form-group">
                <div className="rcslider_custom">
                    <label>{t("LEVERAGE")}</label>: <span>{leverage}x</span>
                    <Slider
                        getAriaValueText={valuetext}
                        aria-labelledby="discrete-slider-custom"
                        step={1}
                        valueLabelDisplay="auto"
                        value={leverage}
                        color={"#00b881"}
                    />
                </div>
            </div>
            <div className="form-group">
                <div className="d-flex justify-content-between">
                    <label>{t("TRADE_SIZE")}:</label> <span>{quantity}</span>{" "}
                </div>
                <div className="d-flex justify-content-between">
                    <label>{t("PIP_VALUE")}:</label> <span>{toFixedDown(quantity / 100, 2)}</span>{" "}
                </div>
                <div className="d-flex justify-content-between">
                    <label>{t("USED_MARGIN")}:</label> <span> <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(margin, 2)} /></span>
                </div>
                <div className="d-flex justify-content-between">
                    <label>{t("TAKE_PROFIT")}:</label>{" "}
                    <span>
                        {" "}
                        <CurrencyFormat
                            displayType={"text"}
                            thousandSeparator={true}
                            value={truncateDecimals(takeProfit, 2)}
                        />
                    </span>
                </div>
                <div className="d-flex justify-content-between">
                    <label>{t("STOP_LOSS")}:</label>{" "}
                    <span>
                        {" "}
                        <CurrencyFormat
                            displayType={"text"}
                            thousandSeparator={true}
                            value={truncateDecimals(stopLoss, 2)}
                        />
                    </span>
                </div>
            </div>
            <div className="d-flex justify-content-between gap-3">
                <button
                    onClick={() => {
                        if (quantity <= 0) {
                            toastAlert("error", `${t("QUANTITY_PLACEHOLDER")}`, "error");
                            return;
                        }
                        setFormValue({
                            ...formValue,
                            ...{ ["isLoss"]: true },
                            ...{ ["stopLoss"]: stopLoss },
                        });
                        setisLossModal(true);
                    }}
                    className="btn btn-danger w-100"
                >
                    {t("STOP_LOSS")}
                </button>
                <button
                    class="btn btn-success w-100"
                    onClick={() => {
                        if (quantity <= 0) {
                            toastAlert("error", `${t("QUANTITY_PLACEHOLDER")}`, "error");
                            return;
                        }
                        setFormValue({
                            ...formValue,
                            ...{ ["isProfit"]: true },
                            ...{ ["takeProfit"]: takeProfit },
                        });
                        setisProfitModal(true);
                    }}
                >
                    {t("TAKE_PROFIT")}
                </button>
            </div>
            <div>
                {loader ?
                    <button class={type === 'buy' ? "primary_btn w-100" : "primary_btn w-100 primary_sell_btn"} disabled={true} >{t("LOADING")} ...</button> :
                    <button onClick={handleSubmit} class={type === 'buy' ? "primary_btn w-100" : "primary_btn w-100 primary_sell_btn"}>{type === 'buy' ? t("BUY") : t("SELL")}</button>
                }
            </div>
            {/* SL model */}
            <Modal
                show={isLossModal}
                onHide={SLCloseModal}
                backdrop="static"
                keyboard={false}
                size="md"
                centered
            >
                <Modal.Header closeButton onClick={SLCloseModal}>
                    <Modal.Title >
                        <h5 className="model_head">{t("STOP_LOSS")}</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div class="form-group">
                            <div className="d-flex justify-content-between gap-10 flex-wrap">
                                <label for="amount" class="form-label">
                                    {t("SP_PRICE")}
                                </label>
                            </div>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="stopLoss"
                                    value={stopLoss}
                                    onChange={handleTPSL}
                                    placeholder={t("STOP_LOSS_PLACEHOLDER")}
                                />
                            </div>
                            <div className="d-flex justify-content-between pt-3 px-5">
                                <label>PnL :</label>{" "}
                                <span className="btn btn-danger">
                                    <CurrencyFormat
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        value={truncateDecimals(slpnl, 4)}
                                    />
                                </span>{" "}
                            </div>
                        </div>
                        <br />
                        <button
                            type="button"
                            className="btn btn-danger btn-outline text-uppercase py-1 ml-2"
                            onClick={SLCloseModal}
                        >
                            {t("CANCEL")}
                        </button>{" "}
                        {loader ? (
                            <button
                                type="button"
                                className="btn btn-success btn-outline text-uppercase py-1 ml-2"
                                disabled={true}
                            >
                                {t("LOADING")}...
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-success btn-outline text-uppercase py-1 ml-2"
                                onClick={handleUpdate}
                            >
                                {t("OK")}
                            </button>
                        )}
                    </form>
                </Modal.Body>
            </Modal>
            {/* TP model */}
            <Modal
                show={isProfitModal}
                onHide={TPCloseModal}
                backdrop="static"
                keyboard={false}
                size="md"
                centered
            >
                <Modal.Header closeButton onClick={TPCloseModal}>
                    <Modal.Title>
                        <h5 className="model_head" >{t("TAKE_PROFIT")}</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div class="form-group">
                            <div className="d-flex justify-content-between gap-10 flex-wrap">
                                <label for="amount" class="form-label">
                                    {t("TP_PRICE")}
                                </label>
                            </div>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="takeProfit"
                                    value={takeProfit}
                                    onChange={handleTPSL}
                                    placeholder={t("TAKE_PROFIT_PLACEHOLDER")}
                                />
                            </div>
                            <div className="d-flex justify-content-between pt-3 px-5">
                                <label>PnL :</label>{" "}
                                <span className="btn btn-success">
                                    <CurrencyFormat
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        value={truncateDecimals(tppnl, 4)}
                                    />
                                </span>{" "}
                            </div>
                        </div>
                        <br />
                        <button
                            type="button"
                            className="btn btn-danger btn-outline text-uppercase py-1 ml-2"
                            onClick={TPCloseModal}
                        >
                            {t("CANCEL")}
                        </button>{" "}
                        {loader ? (
                            <button
                                type="button"
                                className="btn btn-success btn-outline text-uppercase py-1 ml-2"
                                disabled={true}
                            >
                                {t("LOADING")}...
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-success btn-outline text-uppercase py-1 ml-2"
                                onClick={handleUpdate}
                            >
                                {t("OK")}
                            </button>
                        )}
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}


export default Orderplace;